import get from 'lodash/get'

export default function singleAccountEndpointConverter({ data }) {
  return {
    id: get(data, ['id'], null),
    name: get(data, ['attributes', 'name'], null),
    role: get(data, ['attributes', 'role'], null),
  }
}
